import React, { useState } from "react";

/**
 *
 * @param {Object} props
 * @param {string} [props.text]
 * @param {number} props.maxLength         
 * @param {"p"|"span"} [props.as]         
 * @param {string} [props.className]       
 * @param {string} [props.toggleClassName] 
 */
const ExpandableText = ({
  text,
  maxLength,
  as: Tag = "p",
  className = "",
  toggleClassName = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText =
    isLong && !isExpanded ? text.slice(0, maxLength).trimEnd() : text;

  const handleToggle = (event) => {
    event.stopPropagation();
    setIsExpanded((prev) => !prev);
  };

  return (
    <Tag className={className}>
      {displayText}
      {isLong && !isExpanded && "... "}
      {isLong && (
        <span className={toggleClassName} onClick={handleToggle}>
          {isExpanded ? " Read less" : " Read more"}
        </span>
      )}
    </Tag>
  );
};

export default ExpandableText;
